<template>
  <div>
    <!-- <v-text-field
      type="text"
      label="Número de cedula"
      v-model="cedula"
      autofocus
      @keyup.enter="registrar"
    /> -->

    <div v-if="!evento">
      <h2>Seleccione un evento</h2>
      <v-data-table :items="eventos" :headers="headers">
        <template v-slot:[`item.actions`]="props">
          <td v-if="props.item.estado === 'EN_CURSO'">
            <v-btn small color="success" @click="seleccionarEvento(props.item, 'tablero')">VER TABLERO</v-btn>
          </td>
          <td v-if="props.item.estado === 'EN_CURSO'">
            <v-btn class="ml-2" small color="success" @click="seleccionarEvento(props.item, 'consulta')">CONSULTAR
              CI</v-btn>
          </td>
          <td>
            <v-btn class="ml-2" small color="primary" @click="descargar(props.item)" :loading="loading">DESCARGAR</v-btn>
          </td>
        </template>
      </v-data-table>
    </div>
    <div v-if="evento && modo == 'consulta'">
      <h2 class="text-h5">CONSULTA</h2>
      <h2 class="text-h5">{{ evento.nombre }}</h2>
      <h1 class="mt-3 text-h6 text-center">DIGITE NUMERO DE CEDULA</h1>
      <input @blur="enfocar" ref="cedulaInput" type="text" v-model="cedula" style="
          border: 1px solid black;
          margin: auto;
          height: 90px;
          width: 500px;
          padding: 30px;
          display: block;
          font-size: 50px;
        " @keyup.enter="buscar" />

      <v-btn style="
          margin: auto;
          display: block;
          " @click="buscar" class="text-center mt-3">CONSULTAR</v-btn>

      <h1 class="red--text text-center">{{ errorMessage }}</h1>
      <h1 v-if="mostrarMensajeOk && socioRegistrado && !errorMessage" class="green--text text-center">
        SOCIO REGISTRADO CON EXITO!
      </h1>

      <h2 class="text-center mt-2" v-if="persona">
        {{ persona.nombres }} {{ persona.seudonimo ? '(' + persona.seudonimo + ')' : '' }}
      </h2>
      <h2 class="text-center mt-2" v-if="persona">
        CEDULA: {{ persona.cedula }}
      </h2>
      <h2 class="text-center mt-2" v-if="persona">
        {{ persona.tipo }}
      </h2>
      <h2 class="text-center mt-2" v-if="persona">
        ORDEN: {{ persona.orden }}
      </h2>
      <h2 class="text-center mt-2" v-if="persona">
        MESA: {{ persona.mesa }}
      </h2>

    </div>
    <div v-if="evento && modo == 'tablero'">
      <h2 class="text-h5">{{ evento.nombre }}</h2>

      <v-row align="center" justify="center">
        <v-btn class="mt-4" :loading="loading" @click="actualizar">ACTUALIZAR</v-btn>
      </v-row>

      <v-row class="mt-4">
        <v-col cols="6">
          <div style="max-width: 500px">
            <v-data-table dense :items="itemsMemType" :headers="headersMemType" :hide-default-footer="true">
              <template slot="body.append">
                <tr class="">
                  <th></th>
                  <th class="title">Total</th>
                  <th class="title text-end">
                    {{ itemsMemType.reduce((r, a) => r + a.habilitados, 0) }}
                  </th>
                  <th class="title text-end">
                    {{ itemsMemType.reduce((r, a) => r + a.asistencias, 0) }}
                  </th>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-col>

        <v-col cols="6">
          <div style="max-width: 500px">
            <v-data-table dense :items="itemsGrupo" :headers="headersMemType" :hide-default-footer="true"
              disable-pagination>
              <template v-slot:[`item.actions`]="props">
                <v-btn text small @click="verDetalle(props.item)">
                  <v-icon small>edit</v-icon></v-btn>
              </template>
              <template slot="body.append">
                <tr class="">
                  <th></th>
                  <th class="title">Total</th>
                  <th class="title text-end">
                    {{ itemsGrupo.reduce((r, a) => r + a.habilitados, 0) }}
                  </th>
                  <th class="title text-end">
                    {{ itemsGrupo.reduce((r, a) => r + a.asistencias, 0) }}
                  </th>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div style="max-width: 500px">
            <v-data-table dense :items="itemsSinGrupo" :headers="headersMemType" :hide-default-footer="true"
              disable-pagination>

              <template slot="body.append">
                <tr class="">
                  <th></th>
                  <th class="title">Total</th>
                  <th class="title text-end">
                    {{ itemsSinGrupo.reduce((r, a) => r + a.habilitados, 0) }}
                  </th>
                  <th class="title text-end">
                    {{ itemsSinGrupo.reduce((r, a) => r + a.asistencias, 0) }}
                  </th>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-col>
      </v-row>

      <v-row align="center" justify="center">
        <v-btn class="mt-4" :loading="loading" @click="actualizar">ACTUALIZAR</v-btn>
      </v-row>
    </div>

    <VerDetalleGrupo v-if="mostrarDetalle" @close="mostrarDetalle = false" :grupo="grupo" />
  </div>
</template>
<script>
import axios from "axios";
import VerDetalleGrupo from "@/views/eventosSociales/VerDetalleGrupo.vue";
import { saveAs } from "file-saver";

export default {
  data() {
    return {
      loading: false,
      cedula: "",
      mostrarMensajeOk: false,
      mostrarMensajeErr: false,
      errorMessage: "",
      modo: "tablero",
      eventos: [],
      evento: null,
      itemsMemType: [],
      itemsGrupo: [],
      itemsSinGrupo: [],
      mostrarDetalle: false,
      grupo: null,

      headers: [
        { text: "Id", value: "id" },
        { text: "Nombre", value: "nombre" },
        { text: "Estado", value: "estado" },
        { text: "", value: "actions" },
      ],
      headersMemType: [
        { text: "", value: "actions" },
        { text: "Tipo", value: "tipo" },
        { text: "Habilitados", value: "habilitados", align: "end" },
        { text: "Asistencias", value: "asistencias", align: "end" },
      ],
      persona: null,
      socioRegistrado: false,
    };
  },

  components: {
    VerDetalleGrupo,
  },
  methods: {
    enfocar() {
      console.log("enfocamos");
      if (this.$refs.cedulaInput) this.$refs.cedulaInput.focus();
    },
    async descargar(item) {

      this.loading = true;

      const res = await axios.get('/eventoSocial/descargar/' + item.id);
      var blob = await this.b64toBlob(
        res.data.fileContent,
        "application/excel",
        null
      );

      saveAs(blob, res.data.fileName);
      this.loading = false;

    },
    async buscar() {
      this.errorMessage = "";
      this.mostrarMensajeOk = false;

      this.persona = null;

      this.loading = true;

      // await axios.get("/persona/buscar?valor=" + this.cedula + "&propiedad=cedula").then(
      //   response => {
      //     console.log('buscar *****' , response)
      //     if (response.data.length == 0) {

      //       this.errorMessage = "No existe el socio con cedula: " + this.cedula;
      //       return;
      //     }
      //     this.persona = response.data[0];
      //   }
      // ).catch (err => {
      //   this.loading = false;
      //     console.log(err);
      //     if (err && err.response && err.response.data) {
      //       this.errorMessage = err.response.data + " cedula: " + this.cedula;
      //     } else {
      //       this.errorMessage = "Error";
      //     }
      //     return;
      // });

      await axios
        .get(
          "/eventoSocial/checkHabilitado?cedula=" +
          this.cedula +
          "&eventoSocialId=" +
          this.evento.id
        )
        .then((response) => {
          console.log(
            "************************************************CheckHabilitado",
            response
          );
          if (response.data) {
            this.persona = response.data;
          } else {
            this.errorMessage = "Sin datos para CI: " + this.cedula
          }

        })
        .catch((err) => {
          console.log(err);
          alert("ocurrio un error");
        });

      if (this.persona && this.modo === 'registrar') await this.registrar();

      this.cedula = ""

    },
    verDetalle(d) {
      // alert(d.tipo);
      console.log(d);
      this.grupo = d.tipo;
      this.mostrarDetalle = true;
    },
    async seleccionarEvento(evento, modo) {

      this.modo = modo;

      this.evento = evento;

      this.actualizar();
    },
    async actualizar() {
      this.loading = true;

      (this.itemsMemType = []),
        (this.itemsGrupo = []),
        await axios
          .get("/eventoSocial/contadorMemType?eventoSocialId=" + this.evento.id)
          .then((response) => {
            console.log("tablero *****", response);
            this.itemsMemType = response.data;
          })
          .catch((err) => {
            this.loading = false;
            console.log(err);
            if (err && err.response && err.response.data) {
              this.errorMessage = err.response.data;
            } else {
              this.errorMessage = "Error";
            }
          });

      await axios
        .get("/eventoSocial/contadorGrupo?eventoSocialId=" + this.evento.id)
        .then((response) => {
          console.log("tablero *****", response);
          this.itemsGrupo = response.data;
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          if (err && err.response && err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });

      await axios
        .get("/eventoSocial/contadorSinGrupo?eventoSocialId=" + this.evento.id)
        .then((response) => {
          console.log("tablero *****", response);
          this.itemsSinGrupo = response.data;
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          if (err && err.response && err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });

      this.loading = false;

    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
  },
  mounted() {
    axios
      .get("/eventoSocial/")
      .then((response) => {
        console.log("eventoSocial", response);
        this.eventos = response.data.sort((a, b) => b.id - a.id);
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>